import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainContent from './components/MainContent';
import Layout from './components/Layout';
import NewsPage from './components/NewsPage';
import DesignerPage from './components/DesignerPage';
import SunnyHolidayPage from './components/SunnyHolidayPage';
import MaintenancePage from './components/MaintenancePage';
import './styles/App.css';

// TODO: Support response / mobile support - suggest doing via tailwind
// 

function App() {
  return (
    <Router>
      <Routes>
        {/*
          TODO: Confirm that footer should be present on all pages
        */}
        <Route element={<Layout />}>
          <Route path="/" element={<MainContent />} />
          <Route path="/Designer" element={<DesignerPage />} />
          <Route path="/News" element={<NewsPage />} />
          <Route path="/Collection/SunnyHoliday" element={<SunnyHolidayPage />} />

          {/* Online store routes with MaintenancePage */}
          <Route path="/store/limited-edition" element={<MaintenancePage />} />
          <Route path="/store/new-arrival" element={<MaintenancePage />} />
          <Route path="/store/jewelry" element={<MaintenancePage />} />
          <Route path="/store/apparel" element={<MaintenancePage />} />
          <Route path="/store/i-have-a-plant" element={<MaintenancePage />} />
          <Route path="/store/merchandise" element={<MaintenancePage />} />
          <Route path="/store/po-yu-lin" element={<MaintenancePage />} />
          <Route path="/store/parrotman" element={<MaintenancePage />} />
          <Route path="/store/charity-bazaar" element={<MaintenancePage />} />
          <Route path="/store/view-all" element={<MaintenancePage />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;